import { render, staticRenderFns } from "./SnsPostMoveForm.vue?vue&type=template&id=e19304a8&"
import script from "./SnsPostMoveForm.vue?vue&type=script&lang=js&"
export * from "./SnsPostMoveForm.vue?vue&type=script&lang=js&"
import style0 from "./SnsPostMoveForm.vue?vue&type=style&index=0&id=e19304a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports